import Service from "../../AuthService";
const preOrder = {
    getPreOrder(page) {
        return Service.get("/pre_order?page="+page);
    },
    showPreOrder(id) {
        return Service.get("/pre_order/"+id);
    },
    createPreOrder(data) {
        return Service.post("/pre_order" ,data);
    },
    updatePreOrder(id,data) {
        return Service.put("/pre_order/"+id ,data);
    },
    deletePreOrder(id){
        return Service.delete("/pre_order/"+id );
    },
    searchPreOrder(page,material_id,date){
        return Service.post('/pre_order-search?page=' +
            page+
            '&material_id=' +
            material_id+
            '&date='+date);
    }
};
export default preOrder;
